var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.15515 0H21.6376C21.9439 0 22.2377 0.121703 22.4544 0.338336C22.671 0.554969 22.7927 0.848786 22.7927 1.15515V23.4218C22.7928 23.5182 22.7688 23.6131 22.7228 23.6978C22.6769 23.7825 22.6105 23.8544 22.5296 23.9069C22.4488 23.9594 22.3561 23.9908 22.26 23.9983C22.1639 24.0057 22.0675 23.9891 21.9795 23.9497L12.3964 19.6722L2.81323 23.9486C2.72532 23.9879 2.62899 24.0046 2.533 23.9971C2.437 23.9897 2.34439 23.9584 2.26358 23.906C2.18277 23.8537 2.11632 23.782 2.07029 23.6974C2.02426 23.6129 2.00009 23.5181 2 23.4218V1.15515C2 0.848786 2.1217 0.554969 2.33834 0.338336C2.55497 0.121703 2.84879 0 3.15515 0ZM12.3964 13.2842L15.7913 15.0689L15.1433 11.2893L17.8891 8.61165L14.0944 8.05949L12.3964 4.6206L10.6983 8.05949L6.90362 8.61165L9.64941 11.2893L9.00252 15.0689L12.3964 13.2842Z",
    fill: "#2B27D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.1ead64b89f13065fe8c4375bb465ab02.svg";
export { ForwardRef as ReactComponent };